"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("../../global/style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var HelpIcon = function HelpIcon(_ref) {
  var size = _ref.size,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["size", "color"]); // 2.1. RENDER COMPONENT .....................................................


  return _react["default"].createElement(_style.Svg, _extends({
    iconSize: size,
    viewBox: "0 0 50 50"
  }, props), _react["default"].createElement(_style.Path, {
    pathColor: color,
    d: "M28.12,49.78a1.56,1.56,0,0,1-.2-3.11,21.88,21.88,0,1,0-5.84,0,1.56,1.56,0,0,1-.41,3.1,25,25,0,1,1,6.66,0Z"
  }), _react["default"].createElement(_style.Path, {
    pathColor: color,
    d: "M25,31a1.56,1.56,0,0,1-1.56-1.56V24.78A1.56,1.56,0,0,1,25,23.22,6.25,6.25,0,1,0,18.75,17a1.56,1.56,0,0,1-3.12,0,9.38,9.38,0,1,1,10.93,9.24v3.21A1.56,1.56,0,0,1,25,31Z"
  }), _react["default"].createElement(_style.Path, {
    pathColor: color,
    d: "M25,42a4.69,4.69,0,1,1,4.69-4.69A4.7,4.7,0,0,1,25,42Zm0-6.25a1.56,1.56,0,1,0,1.56,1.56A1.56,1.56,0,0,0,25,35.72Z"
  })); // 2.1. END ..................................................................
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. PROP-TYPES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. DEFAULT VALUES .........................................................


HelpIcon.defaultProps = {
  size: 'default',
  color: ''
}; // 3.1. END ....................................................................
// 3.2. TYPES ..................................................................

HelpIcon.propTypes = {
  /**  Defines the size of the icon. */
  size: _propTypes["default"].oneOf(['small', 'default', 'large']),

  /**  Defines the color of the icon. */
  color: _propTypes["default"].string
}; // 3.2. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = HelpIcon; // END OF FILE #################################################################

exports["default"] = _default;